import React from "react";
import Head from "next/head";
import Feature from "../../components/Feature";
import Pic from "../../components/Pic";

const Page = () => (
    <>
        <Head>
            <title>A Stately Wedding</title>
            <meta name="description" content="Photos from the Zadnik wedding with TacBoard. An outdoor ceremony among old, large trees." />
            <link href="https://fonts.googleapis.com/css2?family=Cormorant&display=swap" rel="stylesheet" />
            <link rel="canonical" href="https://tacboard.com/stories/stately-wedding" />
            <meta property="og:title" content="Zadnik Wedding" />
            <meta property="og:description" content="Photos collected with TacBoard at the Zadnik wedding" />
            <meta property="og:image" content="https://tacboard.com/cdn-cgi/image/height=1600,width=1200,fit=crop,metadata=copyright/https://storage.googleapis.com/gallery-prod-tac-images/5a33e0f0ee7a48f0ae624641d9e4ee99.jpg" />
        </Head>

        <Feature>
            <h1>A Stately Wedding</h1>

            <time dateTime="2021-11-29">November 29, 2021</time>

            <p>
                Guests of the Zadnik wedding were treated to a ceremony nestled among a grove of old, large trees.
                An oversized white cloth draped over an enormous bough served as the focal point.
                The reception followed in an elegant hybrid indoor-outdoor space with blue accent lights illuminating the white architecture.
                Stately white columns at the reception tied in with the trees from the ceremony.
            </p>

            <figure>
                <Pic
                    alt="white cloth draped over large bough"
                    src="https://storage.googleapis.com/gallery-prod-tac-images/5a33e0f0ee7a48f0ae624641d9e4ee99.jpg"
                    originalWidth={1200}
                    originalHeight={1600}
                    width={1200}
                    height={1600}
                    widths={[600, 800, 1200]}
                    sizes="(max-width: 800px) 96vw, 800px"
                />

                <figcaption>Trees lent a solemn air to the ceremony</figcaption>
            </figure>

            <figure>
                <Pic
                    alt="a 3 tier white wedding cake"
                    src="https://storage.googleapis.com/gallery-prod-tac-images/45c61c3ecbd745d88fe025baa69f7e59.jpg"
                    originalWidth={2048}
                    originalHeight={1536}
                    width={2048}
                    height={1536}
                    widths={[600, 800, 1600]}
                    sizes="(max-width: 800px) 96vw, 800px"
                />

                <figcaption>The simple white cake almost too perfect to cut</figcaption>
            </figure>

            <figure>
                <Pic
                    alt="wedding bouquet toss"
                    src="https://storage.googleapis.com/gallery-prod-tac-images/c0bcded044f04c588139b9b396d6ab74.jpg"
                    originalWidth={2048}
                    originalHeight={1536}
                    width={2048}
                    height={1536}
                    widths={[600, 800, 1600]}
                    sizes="(max-width: 800px) 96vw, 800px"
                />

                <figcaption>Watch out for those market lights :)</figcaption>
            </figure>

            <figure>
                <Pic
                    alt="wedding reception with TacBoard"
                    src="https://storage.googleapis.com/gallery-prod-tac-images/ad3d1194fb294b5b9193d3742622842e.jpg"
                    originalWidth={1536}
                    originalHeight={2048}
                    width={1536}
                    height={2048}
                    widths={[600, 800, 1536]}
                    sizes="(max-width: 800px) 96vw, 800px"
                />

                <figcaption>The TacBoard display was just inside for guests to enjoy watching photos collected in realtime</figcaption>
            </figure>

            <figure>
                <Pic
                    alt="wedding couple leaving with guests blowing bubbles"
                    src="https://storage.googleapis.com/gallery-prod-tac-images/d3345b864d3e4ec8b9fb62e49b99f834.jpg"
                    originalWidth={1200}
                    originalHeight={1600}
                    width={1200}
                    height={1600}
                    widths={[600, 800, 1200]}
                    sizes="(max-width: 800px) 96vw, 800px"
                />

                <figcaption>The couple was elegantly sent off in a wash of bubbles</figcaption>
            </figure>
        </Feature>
    </>
);

export default Page;
